import createObserver from '@anm/helpers/createObserver';

export default createObserver<{} | null>();
